var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLock = function SvgFadLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 131.01c0-4.424-3.59-8.01-8.007-8.01H72.007A8.004 8.004 0 0 0 64 131.01v84.98c0 4.424 3.59 8.01 8.007 8.01h111.986a8.004 8.004 0 0 0 8.007-8.01v-84.98z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 143.316c0-2.384-1.547-4.316-3.46-4.316H83.46c-1.911 0-3.46 1.936-3.46 4.316v60.368c0 2.384 1.547 4.316 3.46 4.316h89.08c1.911 0 3.46-1.936 3.46-4.316v-60.368z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.874 98.961c-.587-29.853-11.382-52.86-41.93-53.447L120 45.5c-28.285 0-40.487 23.571-39.9 53.415l.699 35.55c3.474.068 16.402.6 16.396.316-.097-4.806-.472-24.028-.62-31.527l-.079-4.024c-.18-9.188-2.727-36.612 25.397-36.052l12.405.357c22.531.433 24.78 14.096 25.194 35.111l.079 4.024c.344 17.51-.446 31.506.62 31.527l16.382.315-.699-35.55z",
    fill: "#000"
  }))));
};
export { SvgFadLock as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-lock.47b00b18.svg";